import React from 'react';
import { connect } from 'react-redux';
import { Input, FormGroup, Label } from 'reactstrap';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../../api-config';
import { auth, userService } from '../../../../../../../services';

import {
    addToPurchase,
    updatePurchase,
    removePurchaseItem
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Success extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            view: "Success",
            title: "Added Checkout",
            Amount: ""
        }
    }

    componentDidMount() {
        this.props.hideSidebar()
    }

    componentDidUpdate(prevProps, prevState) {
    }

    render() {
        return (
            <div className="checkout">
                <h1>Successful</h1>
                <button className="admin-k-button" onClick={this.props.modalToggle}>Close</button>
            </div>
        )
    }
}



function mapStateToProps(state) {
    return {
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, {
    addToPurchase,
    updatePurchase,
    removePurchaseItem
})(Success);